import classnames from 'classnames';
import autobind from 'core-decorators/lib/autobind';


export default class BaseVideosList extends React.PureComponent {

  static propTypes = {
    channelVideoIds: React.PropTypes.array,
    prevPageIds: React.PropTypes.array,
    nextPageIds: React.PropTypes.array,
    videoByIds: React.PropTypes.object,
    videosInRow: React.PropTypes.number,
    thumbnailSize: React.PropTypes.objectOf(React.PropTypes.number),
    className: React.PropTypes.string,
    goBack: React.PropTypes.func,
    goForward: React.PropTypes.func,
  };

  state = {
    currentTransition: '',
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      this.state.currentTransition !== '' &&
      nextState.currentTransition === '' &&
      this.props.channelVideoIds === nextProps.channelVideoIds
    );
  }

  @autobind
  moveListBack() {
    this.setState({ currentTransition: '' });
    this.props.goBack();
    this.currentNode.removeEventListener('animationend', this.moveListBack);
  }

  @autobind
  moveListForward() {
    this.setState({ currentTransition: '' });
    this.props.goForward();
    this.currentNode.removeEventListener('animationend', this.moveListForward);
  }

  @autobind
  toPrevPage() {
    if (this.state.currentTransition) {
      return;
    }

    this.setState({ currentTransition: 'scroll-to-prev' });
    this.currentNode.addEventListener('animationend', this.moveListBack);
  }

  @autobind
  toNextPage() {
    if (this.state.currentTransition) {
      return;
    }

    this.setState({ currentTransition: 'scroll-to-next' });
    this.currentNode.addEventListener('animationend', this.moveListForward);
  }

  toVideoThumbnail() {
    return null;
  }

  get styleNames() {
    const { prevPageIds, nextPageIds, videosInRow } = this.props;
    return classnames(
      'list-wrapper',
      `row-${videosInRow}`,
      this.state.currentTransition,
      {
        'with-paging': prevPageIds.length || nextPageIds.length,
      }
    );
  }

  get list() {
    const { prevPageIds, nextPageIds, channelVideoIds, videosInRow } = this.props;
    const styleNames = classnames(
      'list-wrapper',
      `row-${videosInRow}`,
      this.state.currentTransition
    );

    return (
      <section styleName={styleNames}>
        <div ref={node => (this.currentNode = node)}
             styleName="list current">
          {_.map(channelVideoIds, this.toVideoThumbnail)}
        </div>
        <div styleName="list prev">
          {_.map(prevPageIds, this.toVideoThumbnail)}
        </div>
        <div styleName="list next">
          {_.map(nextPageIds, this.toVideoThumbnail)}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/videos-list/_base.js